<template>
    <component :is="elementType">
        <slot
            v-for="(item, index) in list"
            :item="item"
            name="item"
        >
            <ListItem
                :key="typeof item === 'object' ? item[keyProperty] : `${item}-${index}`"
                :item="item"
            />
        </slot>
    </component>
</template>

<script>
import ListItem from '~/components/common/List/components/ListItem';

export default {
    name: 'List',
    components: {
        ListItem,
    },
    props: {
        list: {
            type: Array,
            required: true,
        },
        isOrdered: {
            type: Boolean,
            default: false,
        },
        keyProperty: {
            type: String,
            default: 'id',
        },
    },
    computed: {
        elementType() {
            return this.isOrdered ? 'ol' : 'ul';
        },
    },
};
</script>
